import React from "react";
import "./rpgAnlayzer.scss";
import ContentContainer from "../../templates/content-container/contentContainer";
import Button, { ButtonSizes, ButtonThemes } from "../../ui-components/button/button";
import { PAGE_IDS } from "../../app/data/common/pageIds";
import { ReactComponent as RedirectIcon } from "../../images/redirect-link.svg";

export const RpgAnalyzer: React.FC<{}> = () => {

  return (
    <ContentContainer
      pageId={PAGE_IDS.RPG_ANALYZER}
      title="RPG Analyzer"
      className="xgs-rpg-analyzer"
    >
      <div className="rpg-card">
        <h2 className="rpg-card__title">
          AI-Powered RPG Business Logic Analysis
        </h2>

        <p className="rpg-card__desc">
          The RPG Analyzer is a separate AI-powered tool designed to interpret
          legacy RPG programs and extract embedded business logic. It helps
          developers, analysts, and management understand complex AS400
          workflows without impacting production systems.
        </p>

        <p className="rpg-card__note">
          Click below to open the RPG Analyzer in a new tab and begin analyzing
          programs.
        </p>

        <Button
          size={ButtonSizes.auto}
          theme={ButtonThemes.blue}
          onClick={() =>
            window.open(
              "https://airpganalyzer.z13.web.core.windows.net/",
              "_blank"
            )
          }
        >
          Proceed to RPG Analyzer <RedirectIcon />
        </Button>
      </div>
    </ContentContainer>
  );
};
